module.exports = __webpack_public_path__ + "i18n/ru_d638f974669d08c1f29bf3c3a7c1f3aa.json";


//////////////////
// WEBPACK FOOTER
// ./app/assets/i18n/ru.json
// module id = 2MCb
// module chunks = 153